// extracted by css-extract-rspack-plugin
export default {"root":"root-cg_r4D","img":"img-rYCI1t","closeIconContainer":"closeIconContainer-c3YcSf","svg":"svg-dWwvkZ"};